<template>
  <div
    class="flex flex-col gap-4 border-t border-gray-200 px-4 py-4 sm:flex-row sm:items-center sm:justify-between"
  >
    <div class="flex items-center gap-2 text-sm text-gray-600">
      <label class="whitespace-nowrap font-medium text-gray-700">
        {{ translations.rows_per_page || "Rows per page:" }}
      </label>
      <select
        :value="pagination.pageSize"
        class="rounded-md border-0 py-1.5 pl-3 pr-8 text-sm font-medium text-gray-900 ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
        @change="(e) => $emit('handlePageSizeChange', e)"
      >
        <option v-for="pageSize in pageSizes" :key="pageSize" :value="pageSize">
          {{ translations.show || "Show" }} {{ pageSize }}
        </option>
      </select>
    </div>

    <div class="whitespace-nowrap text-sm text-gray-600">
      {{ translations.showing || "Showing" }}
      <strong class="font-semibold text-gray-900">{{ currentPage }}</strong>
      {{ translations.of || "of" }}
      <strong class="font-semibold text-gray-900">{{ totalPages }}</strong>
      ({{ totalCount.toLocaleString() }} {{ translations.total || "Total" }})
    </div>

    <nav class="flex items-center gap-1">
      <button
        type="button"
        class="cursor-pointer whitespace-nowrap rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 transition-colors hover:border-blue-300 hover:bg-blue-50 hover:text-blue-700 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-gray-300 disabled:hover:bg-white disabled:hover:text-gray-700"
        :disabled="currentPage <= 1"
        @click="$emit('getPage', 1)"
      >
        {{ translations.first || "First" }}
      </button>

      <span v-if="currentPage > 1" class="px-1 text-gray-400">&hellip;</span>

      <button
        v-if="currentPage >= totalPages && currentPage - 2 > 0"
        type="button"
        class="page-btn"
        @click="$emit('getPage', currentPage - 2)"
      >
        {{ currentPage - 2 }}
      </button>

      <button
        v-if="currentPage > 1"
        type="button"
        class="page-btn"
        @click="$emit('getPage', currentPage - 1)"
      >
        {{ currentPage - 1 }}
      </button>

      <button
        type="button"
        class="page-btn page-btn-active"
        :disabled="currentPage < 1"
        @click="$emit('getPage', currentPage)"
      >
        {{ currentPage }}
      </button>

      <button
        v-if="currentPage < totalPages"
        type="button"
        class="page-btn"
        :disabled="currentPage >= totalPages"
        @click="$emit('getPage', currentPage + 1)"
      >
        {{ currentPage + 1 }}
      </button>

      <button
        v-if="currentPage <= 1 && totalPages >= 3"
        type="button"
        class="page-btn"
        @click="$emit('getPage', currentPage + 2)"
      >
        {{ currentPage + 2 }}
      </button>

      <span v-if="currentPage < totalPages" class="px-1 text-gray-400"
        >&hellip;</span
      >

      <button
        type="button"
        class="cursor-pointer whitespace-nowrap rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 transition-colors hover:border-blue-300 hover:bg-blue-50 hover:text-blue-700 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-gray-300 disabled:hover:bg-white disabled:hover:text-gray-700"
        :disabled="currentPage >= totalPages"
        @click="$emit('getPage', totalPages)"
      >
        {{ translations.last || "Last" }}
      </button>
    </nav>
  </div>
</template>

<script>
export default {
  props: {
    pagination: Object,
    currentPage: Number,
    totalPages: Number,
    totalCount: Number,
    translations: Object,
  },
  data() {
    return {
      pageSizes: [10, 25, 50, 100],
    };
  },
  computed: {},
  beforeMount() {},
  methods: {},
};
</script>

<style scoped>
.page-btn {
  display: flex;
  height: 2.25rem;
  width: 2.25rem;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  border: 1px solid transparent;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  transition:
    background-color 0.15s ease-in-out,
    color 0.15s ease-in-out;
}

.page-btn:hover {
  background-color: var(--color-blue-50, #eff6ff);
  color: var(--color-blue-700, #1d4ed8);
}

.page-btn-active,
.page-btn-active:hover {
  border-color: var(--color-blue-600, #2563eb);
  background-color: var(--color-blue-600, #2563eb);
  color: #fff;
  font-weight: 600;
}
</style>
